import { XIcon } from '@phosphor-icons/react';
import { pillStylesBase, pillVariants } from './base-pill-styles';
import { cn } from '@/lib/utils';

interface PillListProps {
  values: string[];
  onRemove?: (index: number) => void;
  onClick?: (value: string, index: number) => void;
  className?: string;
  removable?: boolean;
  clickable?: boolean;
}

export function PillList({
  values,
  onRemove,
  onClick,
  className = '',
  removable = false,
  clickable = false,
}: PillListProps) {
  const handleRemove = (index: number, e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove?.(index);
  };

  const handleClick = (value: string, index: number) => {
    if (clickable) {
      onClick?.(value, index);
    }
  };

  return (
    <div className={cn(pillStylesBase.container, className)}>
      {values?.map((value, index) => (
        <div
          key={index}
          className={pillVariants({
            variant: clickable ? 'clickable' : 'default',
          })}
          onClick={() => handleClick(value, index)}
        >
          <span>{value}</span>
          {removable && (
            <button
              type="button"
              onClick={(e) => handleRemove(index, e)}
              className={pillStylesBase.removeButton}
              aria-label={`Remove ${value}`}
            >
              <XIcon className={pillStylesBase.removeIcon} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
